import { lensAddOnStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-add-on.js";
import { lensAddOnVariantStep } from "../../../../../shared/state/configurator/steps/shared/lens-add-on-variant.js";
import { lensPackageStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-package.js";
import { lensTypeStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-type.js";
import { lensTypeVariantStep } from "../../../../../shared/state/configurator/steps/shared/lens-type-variant.js";
import { prescriptionEntrySelectionStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-entry-selection.js";
import { prescriptionFormStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-form.js";
import { prescriptionUploadStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-upload.js";
import { prescriptionValidationStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-validation.js";
import { reviewStepBase } from "../../../../../shared/state/configurator/steps/shared/review.js";
const labelKeys = {
  lensType: {
    stepIndicatorTitle: "products.glasses.configurator.step.lensType",
    title: "products.glasses.lensType.title",
    description: "products.glasses.lensType.description"
  },
  lensTypeVariant: {
    title: "products.glasses.lensTypeVariant.title",
    description: "products.glasses.lensTypeVariant.description"
  },
  prescriptionEntrySelection: {
    stepIndicatorTitle: "products.glasses.configurator.step.prescription",
    title: "products.glasses.prescriptionEntry.title",
    description: "products.glasses.prescriptionEntry.description"
  },
  prescriptionUpload: {
    title: "products.glasses.prescriptionUpload.title",
    description: "products.glasses.prescriptionUpload.description"
  },
  prescriptionForm: {
    title: "products.glasses.prescriptionForm.title",
    description: "products.glasses.prescriptionForm.description"
  },
  prescriptionValidation: {
    stepIndicatorTitle: "products.glasses.configurator.step.prescriptionValidation",
    title: "products.glasses.validationStep.title",
    description: "products.glasses.validationStep.description"
  },
  lensPackage: {
    stepIndicatorTitle: "products.glasses.configurator.step.lensPackage",
    title: "products.glasses.lensPackage.title",
    description: "products.glasses.lensPackage.description"
  },
  lensAddOn: {
    stepIndicatorTitle: "products.glasses.configurator.step.lensAddOn",
    title: "products.glasses.lensAddOn.title",
    description: "products.glasses.lensAddOn.description"
  },
  lensAddOnVariant: {
    title: "products.glasses.lensAddOnVariant.title",
    description: "products.glasses.lensAddOnVariant.description"
  },
  review: {
    stepIndicatorTitle: "products.glasses.configurator.step.review",
    title: "products.glasses.review.title",
    description: "products.glasses.review.description"
  }
};
const stepsMap = {
  lensType: {
    ...lensTypeStepBase,
    labelKeys: {
      ...labelKeys.lensType,
      alternativeCta: "products.glasses.lensType.selectVariant"
    }
  },
  lensTypeVariant: {
    ...lensTypeVariantStep,
    labelKeys: labelKeys.lensTypeVariant
  },
  prescription: {
    ...prescriptionEntrySelectionStepBase,
    labelKeys: labelKeys.prescriptionEntrySelection
  },
  prescriptionUpload: {
    ...prescriptionUploadStepBase,
    labelKeys: labelKeys.prescriptionUpload
  },
  prescriptionForm: {
    ...prescriptionFormStepBase,
    labelKeys: labelKeys.prescriptionForm
  },
  prescriptionValidation: {
    ...prescriptionValidationStepBase,
    labelKeys: labelKeys.prescriptionValidation
  },
  lensPackage: {
    ...lensPackageStepBase,
    labelKeys: labelKeys.lensPackage
  },
  lensAddOn: {
    ...lensAddOnStepBase,
    labelKeys: {
      ...labelKeys.lensAddOn,
      alternativeCta: "products.glasses.lensAddOn.selectVariant"
    }
  },
  lensAddOnVariant: {
    ...lensAddOnVariantStep,
    labelKeys: labelKeys.lensAddOnVariant
  },
  review: {
    ...reviewStepBase,
    labelKeys: labelKeys.review
  }
};
export {
  stepsMap
};
//# sourceMappingURL=index.js.map
